module.exports = __webpack_public_path__ + "static/img/storagebenefit3.b995dd05.png";